const _find = require('../utils/find.js');
const Immutable = require('seamless-immutable');
const clonedeep = require('../utils/clone.js');
const uniqBy = require('../utils/uniqBy.js');
import moment from 'moment';

import config from '../config';
import { removePurchaseAndDishPriviege } from './privilege/change-purchase-calculator';
import { getBrowserCode } from './order-source-helper';
import chargeCalcaltor from './privilege/index';
import { getRequestUrl } from './http-request-helper';
import { dateUtility, replaceEmojiWith, checkEmojiWith, checkInvalidSymbol, getParamFromSession, formatPrice, isFormalMeal } from './common-helper';
import {
  CarryTypes,
  MemberPrivTypes,
  CouponPrivTypes,
  CouponTypes,
  MinDiscountedAmount,
  CalcWay,
  OnlyPromptlyDelivery,
  CouponSubmitDataTypes,
  PayWay,
  ApplyProductType,
  MULTI_PROMOTIONS,
  MEMBER_PRICE,
  SINGLE_PROMOTIONS,
  FULL_PROMOTIONS,
  DISCOUNT_CARDS,
  FULL_COUNT_PROMOTIONS,
  LIMIT_PROMOTIONS,
} from './const';
import {
  getDishesPrice,
  getDishesCount,
  getUrlParam,
  isSingleDishWithoutProps,
  getDishPrice,
  getOrderPrice,
  getDishMemberPrice,
  getActivityBenefitMaxId,
  getDishesBasePrice,
  getDishIds,
  countDishesNumber,
} from './dish-helper';

import { formatMessage } from '../intl/helper';
import orderMessage from '../intl/messages/order';
import actionText from '../intl/messages/action';
import dishMenuMessage from '../intl/messages/dish-menu';
import addressText from '../intl/messages/address';
import activateText from '../intl/messages/activate';
import dinnerDetailText from '../intl/messages/dinner-detail';

const shopId = getUrlParam('shopId');
const type = getUrlParam('type');

const calcStageFee = (price, stages) => {
  if (!stages || !stages.length) {
    return 0;
  }

  const stage = stages.find(item => price >= item.startAmount && price < item.endAmount);

  return stage ? stage.amount : 0;
};

/**
 * 判断一个对象是否为空
 */
exports.isEmptyObject = obj => Object.keys(obj || {}).length === 0;

/**
 * 判断默认应该选中的配送时间
 */
const getDefaultSelectedDateTime = (exports.getDefaultSelectedDateTime = (timeTable, defaultSelectedDateTime, type) => {
  const selectedDateTime = { date: '', time: '' };
  console.log('timeTable', timeTable);
  if (!timeTable) {
    return selectedDateTime;
  }

  console.log('defaultSelectedDateTime', defaultSelectedDateTime);
  if (defaultSelectedDateTime) {
    const times = timeTable[defaultSelectedDateTime.date];

    if (times && times.indexOf(defaultSelectedDateTime.time) !== -1) {
      return Object.assign(selectedDateTime, defaultSelectedDateTime);
    }
  }

  const todayStr = dateUtility.format(new Date());
  let defaultDate = '';

  for (const key in timeTable) {
    if (!timeTable.hasOwnProperty(key)) {
      continue;
    }

    const firstValue = type === 'ws' ? '' : timeTable[key] && timeTable[key][0];
    const isToday = todayStr === key;

    if (!defaultDate || isToday) {
      selectedDateTime.date = defaultDate = key;
      selectedDateTime.time = firstValue;
      if (isToday) {
        break;
      }
    }
  }

  return selectedDateTime;
});

/**
 * getDefaultWSTimeProps
 */
exports.getDefaultWSTimeProps = (payload, type) => {
  const { onlyPromptlyDelivery, timeJson, defaultSelectedDateTime } = payload || {};

  if (onlyPromptlyDelivery === OnlyPromptlyDelivery.OPEN) {
    return { date: '', time: '尽快送达' };
  }
  return getDefaultSelectedDateTime(timeJson, defaultSelectedDateTime, type);
};

/**
 * serviceStatus
 */
exports.getMoreDishesUrl = function(serviceStatus) {
  const orderParam = serviceStatus.orderId ? `&orderId=${serviceStatus.orderId}` : '';
  const tableParam = serviceStatus.tableId ? `&tableId=${serviceStatus.tableId}` : '';
  const initializeUrl =
    type === 'TS'
      ? getRequestUrl(config.dishMenu4DinnerURL, {
          shopId,
          type: 'TS',
          addDishes: true,
        })
      : getRequestUrl(config.dishMenu4DinnerURL, { shopId, type: 'WM' });

  return !serviceStatus.tableId ? initializeUrl : `${initializeUrl}${tableParam}${orderParam}`;
};

/**
 * 下单成功以后为后台设置一个callbackUrl
 */
exports.setCallbackUrl = id => {
  const callbackUrl = type === 'TS' ? `http://${location.host}/order/orderallDetail` : `http://${location.host}/order/takeOutDetail`;
  const callbackUrlWithEncode = encodeURIComponent(getRequestUrl(callbackUrl, { shopId, orderId: id }));

  sessionStorage.setItem('rurl_payDetaill', JSON.stringify(callbackUrlWithEncode));

  return callbackUrlWithEncode;
};

/**
 * 初始化时间选择器
 */
exports.initializeTimeTable = times => {
  if (!times || typeof times !== 'object') {
    return times;
  }

  const now = new Date();
  const todayTimes = times[dateUtility.format(now)];

  if (!todayTimes || !todayTimes.length) {
    return times;
  }

  const firstItem = todayTimes[0];

  if (firstItem === '立即送餐') {
    todayTimes[0] = '尽快送达';
  }

  return times;
};

/**
 * 判断支付方式是否可用
 */
exports.isPaymentAvaliable = (payment, diningForm, isPickupFromFrontDesk, sendAreaId, selfPayType, sendPayType, limit) => {
  // 正餐先付仅供送餐到桌
  if (isFormalMeal(diningForm)) {
    return sendPayType.indexOf(payment);
  }

  const tabActive = limit || JSON.parse(localStorage.basicListInfo || '{}').way || 'ws';

  if (type === 'WM') {
    if (tabActive === 'ws') {
      return sendPayType.indexOf(payment);
    }
    return selfPayType.indexOf(payment);
  }

  return isPickupFromFrontDesk ? selfPayType.indexOf(payment) : sendPayType.indexOf(payment);
};

/**
 * 微信卡券核销
 */
exports.handleWeixinCard = (couponList, bool) => {
  couponList.forEach(coupon => {
    if (coupon.weixinValue) {
      coupon.coupRuleBeanList = [];
      coupon.coupDishBeanList = [];
    }

    if (!coupon.coupRuleBeanList) {
      coupon.coupRuleBeanList = [];
    }

    if (!coupon.coupDishBeanList) {
      coupon.coupDishBeanList = [];
    }

    coupon.id = String(coupon.id);
  });

  return bool ? couponList : (couponList || []).filter(coupon => !coupon.weixinValue);
};

/**
 * 判断支付方式是否应该checked
 */
exports.shouldPaymentAutoChecked = (payment, diningForm, isPickupFromFrontDesk, sendAreaId, selfPayType, sendPayType, limit) => {
  // 正餐先付，指定送餐到桌
  if (isFormalMeal(diningForm)) {
    return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
  }

  const tabActive = limit || JSON.parse(localStorage.basicListInfo || '{}').way || 'ws';

  if (getUrlParam('type') === 'WM') {
    if (tabActive === 'ws') {
      return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
    }
    return selfPayType && selfPayType.indexOf(',') !== -1 ? payment === selfPayType.split(',')[0] : payment === selfPayType;
  }

  if (isPickupFromFrontDesk) {
    return selfPayType && selfPayType.indexOf(',') !== -1 ? payment === selfPayType.split(',')[0] : payment === selfPayType;
  }

  return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
};

/**
 * 获取线下支付方式在不通场景中的名字
 */
exports.getOfflinePaymentName = (sendAreaId, sellType) => {
  if (type === 'TS') {
    return '线下支付';
  }

  return sendAreaId === 0 && sellType === 'zt' ? formatMessage(orderMessage.orderOfflinePayment) : formatMessage(orderMessage.orderCashOnDelivery);
};

/**
 * 获取被选中的桌台信息
 */
exports.getSelectedTable = tableProps => ({
  area: _find(tableProps.areas, { isChecked: true }),
  table: _find(tableProps.tables, { isChecked: true }),
});

/**
 * 判断前台自取是否应该自动选中
 */
exports.isPickUpAutoChecked = serviceProps => ({
  name: '前台自取',
  isChecked: !!serviceProps && serviceProps.indexOf('totable') === -1,
  id: 'way-of-get-diner',
});

/**
 * 初始化桌台信息
 */
exports.initializeAreaAdnTableProps = areaList => {
  let tableList = [];

  (areaList || []).forEach((item, index) => {
    item.id = item.areaId;

    if (item.tables) {
      item.tables.forEach(table => {
        table.areaId = item.areaId;
      });
    }

    tableList = tableList.concat(item.tables || []);
  });

  if (!areaList || !tableList || !areaList.length || !tableList.length) {
    return {
      areaList: null,
      tableList: null,
      isEditable: false,
    };
  }

  const tableId = getUrlParam('tableId') || sessionStorage.getItem('tableId');

  if (!tableId) {
    tableList.forEach(table => {
      table.id = table.tableId;
    });

    return {
      areaList,
      tableList,
      isEditable: true,
    };
  }

  tableList.forEach(table => (table.synFlag === tableId ? ((_find(areaList, { id: table.areaId }).isChecked = true), (table.isChecked = true)) : false));

  if (_find(tableList, { isChecked: true }) !== undefined) {
    tableList.forEach(table => {
      table.id = table.tableId;
    });

    return {
      areaList,
      tableList,
      isEditable: false,
    };
  }

  return {
    areaList: null,
    tableList: null,
    isEditable: true,
  };
};

/**
 * 结算相关
 * 从localStorage中获取餐盒费
 */
const getDishBoxPrice = (exports.getDishBoxPrice = () => {
  const dishBoxPrice = localStorage.getItem('dishBoxPrice');

  if (type === 'TS' || !dishBoxPrice || dishBoxPrice === 0) {
    return 0;
  }

  return parseFloat(dishBoxPrice);
});

/**
 * 计算配送费
 */
const countDeliveryPrice = (exports.countDeliveryPrice = deliveryProps => {
  if (type === 'TS') {
    return 0;
  }

  if (!deliveryProps || !deliveryProps.deliveryPrice) {
    return 0;
  }

  return deliveryProps.deliveryPrice;
});

/**
 * 获取整单附加费（正餐 + 快餐）
 * @param {object} serviceProps
 */
const getOrderExtraPrice = (serviceProps = {}) => {
  let extraPrice = 0;
  const { benefitProps, diningForm } = serviceProps;
  if (
    (benefitProps && (benefitProps.isPriviledge || isFormalMeal(diningForm))) ||
    (benefitProps && !isFormalMeal(diningForm) && getUrlParam('type') === 'TS')
  ) {
    extraPrice = benefitProps.extraPrice;
  }

  return extraPrice;
};
exports.getOrderExtraPrice = getOrderExtraPrice;

/**
 * 计算进入页面时的总价
 * 自动抹零现规则是在积分，优惠券，折扣换算完以后才执行
 * 折扣信息为serviceProps.discountProps.inUseDiscount,已经计算好了的
 */
exports.countTotalPriceWithoutBenefit = (dishesPrice, deliveryProps, serviceProps) => {
  const total = [
    dishesPrice, // 菜品初始价格
    getDishBoxPrice(), // 餐盒费
    +countDeliveryPrice(deliveryProps), // 配送费
    // getOrderExtraPrice(serviceProps), // 附加费
  ].reduce((p, n) => p + n);

  return parseFloat(total.toFixed(2));
};

// 计算被优惠的加价部分 如果ableAddPriceDiscount为false 则应为0
const getPrivChangePriceByOrder = (order, saleType) => {
  const { groups, dishIngredientInfos, dishPropertyTypeInfos, count } = order;
  let diMemberPrice = 0;
  let dpMemberPrice = 0;
  let groupMemberPrice = 0;

  if (Array.isArray(dishIngredientInfos)) {
    diMemberPrice = dishIngredientInfos.reduce((diPrice, ingredient) => {
      const { memberReprice = 0, reprice = 0, isChecked } = ingredient;
      // return isChecked && memberReprice ? diPrice + (reprice - memberReprice) : diPrice;
      return isChecked && memberReprice >= 0 ? diPrice + (reprice - memberReprice) : diPrice; // 消除memberReprice为0的影响
    }, 0);
  }

  if (Array.isArray(dishPropertyTypeInfos)) {
    dishPropertyTypeInfos.forEach(dishProp => {
      const { properties } = dishProp;
      if (Array.isArray(properties)) {
        dpMemberPrice += properties.reduce((dpPrice, prop) => {
          const { memberReprice = 0, reprice = 0, isChecked } = prop;
          // return isChecked && memberReprice ? dpPrice + (reprice - memberReprice) : dpPrice;
          return isChecked && memberReprice >= 0 ? dpPrice + (reprice - memberReprice) : dpPrice; // 消除memberReprice为0的影响
        }, 0);
      }
    });
  }

  if (Array.isArray(groups)) {
    groups.forEach(group => {
      const { childInfos } = group;
      if (Array.isArray(childInfos)) {
        childInfos.forEach(child => {
          const { order: subOrder, marketPrice = 0, memberMarketPrice = 0 } = child;
          let num = 0;
          if (Array.isArray(subOrder)) {
            subOrder.forEach(subOrderItem => {
              num += subOrderItem.count;
              groupMemberPrice += getPrivChangePriceByOrder(subOrderItem, subOrder.saleType || 2);
            });
          } else if (!isNaN(subOrder)) {
            num = subOrder;
          }

          groupMemberPrice += num * (marketPrice - memberMarketPrice);
        });
      }
    });
  }
  const newCount = saleType === 1 ? 1 : count;
  return +((diMemberPrice + dpMemberPrice + groupMemberPrice) * newCount).toFixed(2);
};

/**
 * 计算会员价格 优惠了多少钱
 */
const countMemberPrice = (exports.countMemberPrice = (isDiscountChecked, orderedDishes, discountProps) => {
  if (!isDiscountChecked) {
    return 0;
  }

  const { discountList, discountType, discount, ableAddPriceDiscount } = discountProps;
  // 此处新加 数组去重
  const n = {};
  const validDiscountList = (discountList || [])
    .map((item, index) => {
      if (item.dishId && !n[item.dishId]) {
        n[item.dishId] = true;
        return item;
      }

      return null;
    })
    .filter(item => !!item);

  const discountPriceList = [];
  const newOrderedDishes = Immutable.from([].concat(orderedDishes));

  for (let i = 0; i < newOrderedDishes.length; i++) {
    if (!newOrderedDishes[i].isRelatedToCoupon) {
      continue;
    }

    const dishCount = getDishesCount([newOrderedDishes[i]]);

    if (dishCount <= newOrderedDishes[i].relatedCouponCount) {
      continue;
    }

    if (isSingleDishWithoutProps(newOrderedDishes[i])) {
      Immutable.merge(newOrderedDishes[i], {
        order: dishCount - newOrderedDishes[i].relatedCouponCount,
      });
    } else {
      const orderLength = newOrderedDishes[i].order.length;

      for (let j = 0; j < orderLength; j++) {
        if (newOrderedDishes[i].order[j].count <= newOrderedDishes[i].relatedCouponCount) {
          Immutable.merge(newOrderedDishes[i], {
            relatedCouponCount: newOrderedDishes[i].relatedCouponCount - newOrderedDishes[i].order[j].count,
          });
          Immutable.merge(newOrderedDishes[i].order[j], { count: 0 });
        } else {
          Immutable.merge(newOrderedDishes[i].order[j], {
            count: newOrderedDishes[i].order[j].count - newOrderedDishes[i].relatedCouponCount,
          });
        }
      }
    }
  }

  let calcExp = null;

  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    calcExp = (price, count, discountValue, orderPrice, privChangePrice) => {
      const privAmount = (1 - discountValue / 10) * price * count + privChangePrice;
      const realAmount = Math.max(MinDiscountedAmount, orderPrice - privAmount);

      return Math.max(0, orderPrice - realAmount);
    };
  } else {
    calcExp = (price, count, discountValue) => Math.max(price - discountValue, 0) * count;
  }

  const useDiscountDishes = newOrderedDishes.filter(dish => !dish.noUseDiscount && !dish.purchaseBenefit);

  useDiscountDishes.forEach(orderedDish => {
    const dishDiscount = validDiscountList.find(item => item.dishId === orderedDish.id);
    if (!dishDiscount && discountType !== MemberPrivTypes.UNIFIED_DISCOUNT) {
      return;
    }

    const discountValue = discountType === MemberPrivTypes.UNIFIED_DISCOUNT ? discount : dishDiscount.value;

    if (isSingleDishWithoutProps(orderedDish)) {
      const orderPrice = getDishPrice(orderedDish);
      const privChangePrice = 0;
      discountPriceList.push(calcExp(orderedDish.marketPrice, getDishesCount([orderedDish]), discountValue, orderPrice, privChangePrice));
    } else {
      orderedDish.order.forEach(order => {
        const orderPrice = getOrderPrice(orderedDish, order); // 总价
        const privChangePrice = ableAddPriceDiscount ? getPrivChangePriceByOrder(order) : 0; // 被优惠的配料价格
        const discountPrice = calcExp(orderedDish.marketPrice, order.count, discountValue, orderPrice, privChangePrice);
        discountPriceList.push(Math.min(discountPrice, orderPrice));
      });
    }
  });

  return parseFloat(discountPriceList.reduce((p, c) => p + c, 0).toFixed(2));
});

/**
 * 计算雅座的积分优惠
 */
const getMaxIntegralCanBeUsedForYaZuo = (exports.getMaxIntegralCanBeUsedForYaZuo = (integralsInfo, canBeUsedCommutation) => {
  if (canBeUsedCommutation <= 0 || !integralsInfo) {
    return {
      maxIntegralCanBeUsed: null,
      maxDiscount: null,
    };
  }

  const { integralRate, integral } = integralsInfo;

  const discountByIntegral = parseFloat((integral * integralRate).toFixed(2));

  if (discountByIntegral <= canBeUsedCommutation) {
    return {
      maxIntegralCanBeUsed: integral,
      maxDiscount: discountByIntegral,
    };
  }

  const maxIntegralCanBeUsed = Math.ceil(canBeUsedCommutation / integralRate);
  const maxDiscount = parseFloat((maxIntegralCanBeUsed * integralRate).toFixed(2));

  return {
    maxIntegralCanBeUsed,
    maxDiscount: maxDiscount > canBeUsedCommutation ? canBeUsedCommutation : maxDiscount,
  };
});

/**
 * 计算积分换算金额
 */
exports.countIntegralsToCash = (canBeUsedCommutation, integralsInfo) => {
  // 不存在积分对象或者总额为0
  if (canBeUsedCommutation <= 0 || !integralsInfo) {
    return {
      commutation: 0,
      integralInUsed: 0,
    };
  }
  // 雅座的积分兑换
  if (!integralsInfo.exchangeCashValue || !integralsInfo.exchangeIntegralValue) {
    const { maxIntegralCanBeUsed, maxDiscount } = getMaxIntegralCanBeUsedForYaZuo(integralsInfo, canBeUsedCommutation);

    return {
      commutation: maxDiscount,
      integralInUsed: maxIntegralCanBeUsed,
    };
  }

  const limitType = integralsInfo.limitType;

  const canUsesIntegralTimes = Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue);
  if (limitType === 1) {
    const integralInUsed =
      canUsesIntegralTimes * integralsInfo.exchangeIntegralValue < integralsInfo.integral
        ? canUsesIntegralTimes * integralsInfo.exchangeIntegralValue
        : Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue;
    return {
      commutation: (integralInUsed / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeCashValue,
      integralInUsed,
    };
  } else if (limitType === 2) {
    if (integralsInfo.integral > integralsInfo.limitIntegral) {
      const moneyLimit = Math.floor(integralsInfo.limitIntegral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeCashValue;
      return {
        commutation:
          moneyLimit > canBeUsedCommutation ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeCashValue : moneyLimit,
        integralInUsed:
          moneyLimit > canBeUsedCommutation
            ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeIntegralValue
            : Math.floor(integralsInfo.limitIntegral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue,
      };
    }

    const noLimitMoney = Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeCashValue;
    return {
      commutation:
        noLimitMoney > canBeUsedCommutation
          ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeCashValue
          : noLimitMoney,
      integralInUsed:
        noLimitMoney > canBeUsedCommutation
          ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeIntegralValue
          : Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue,
    };
  }

  return false;
};

/**
 * 获取关联菜品的礼品券可以省多少钱
 */
const countRelatedDishGiftCouponPrice = (dish, dishCount, dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps) => {
  if (!serviceProps) {
    return;
  }

  relatedCouponDish.name = dish.name;
  relatedCouponDish.number = coupon.dishNum;

  const { wholeOrderBenefit, activityBenefit } = serviceProps;
  let countActivityBenefit = 0;
  const isSingleDish = isSingleDishWithoutProps(dish);
  let activityBenefitNum = 0;

  if (wholeOrderBenefit && wholeOrderBenefit.isChecked) {
    activityBenefitNum = (isSingleDish ? dish.order : dish.order[0].count) || 1;
    countActivityBenefit =
      activityBenefit.privilegePrices[dish.id] && activityBenefit.privilegePrices[dish.id].prices.reduce((c, p) => c + p) / activityBenefitNum;
  } else {
    const activityBenefitMoney = isSingleDish ? dish.activityBenefit : dish.order[0].activityBenefit;
    activityBenefitNum = (isSingleDish ? dish.activityBenefitNum : dish.order[0].activityBenefitNum) || 1;

    if (coupon.dishNum <= activityBenefitNum) {
      countActivityBenefit = (activityBenefitMoney / activityBenefitNum) * coupon.dishNum || 0;
    } else {
      countActivityBenefit = activityBenefitMoney;
    }
  }

  const realDishBenefitPrice = countActivityBenefit;

  let partOne = dish.marketPrice * (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber) - realDishBenefitPrice;
  let partTwo = (dishPrice / dishCount) * (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber) - realDishBenefitPrice;
  let partThree = dish.marketPrice * dishCount - realDishBenefitPrice;
  let partFour = dishPrice - realDishBenefitPrice;

  if (!(wholeOrderBenefit && wholeOrderBenefit.isChecked)) {
    // if (!dish.noUseDiscount && dish.isMember && dish.memberPrice) {
    if (!dish.noUseDiscount && dish.isMember && (dish.memberPrice !== null && dish.memberPrice !== undefined)) {
      partOne = partTwo = partThree = partFour = getDishMemberPrice(dish);
    }
  }

  if (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber > 0) {
    if (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber < dishCount) {
      benefitMoneyCollection.push(dish.marketPrice < dishPrice / dishCount ? partOne : partTwo);
    } else {
      benefitMoneyCollection.push(dish.marketPrice < dishPrice / dishCount ? partThree : partFour);
    }
    relatedCouponDish.joinBenefitDishesNumber =
      coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber < dishCount ? coupon.dishNum : relatedCouponDish.joinBenefitDishesNumber + dishCount;
  }
};

/**
 * 获取与礼品券有关的菜品优惠情况
 */
const getRelatedToDishCouponProps = (exports.getRelatedToDishCouponProps = (coupon, serviceProps, orderedDishesProps) => {
  const dishesList = orderedDishesProps || JSON.parse(localStorage.getItem('lastOrderedDishes')) || {};
  const relatedCouponDish = {
    name: null,
    number: null,
    couponValue: null,
    joinBenefitDishesNumber: 0,
  };
  const benefitMoneyCollection = [];

  (dishesList.dishes || []).forEach(dish => {
    if (isSingleDishWithoutProps(dish)) {
      if (dish.brandDishId === coupon.dishId) {
        const dishCount = getDishesCount([dish]);
        const dishPrice = getDishPrice(dish);
        countRelatedDishGiftCouponPrice(dish, dishCount, dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps);
      }
    } else {
      dish.order.forEach(order => {
        if (dish.brandDishId === coupon.dishId) {
          const dishCount = order.count;
          const dishPrice = getOrderPrice(dish, order);
          countRelatedDishGiftCouponPrice(dish, dishCount, dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps);
        }
      });
    }
  });

  relatedCouponDish.couponValue = benefitMoneyCollection.length ? parseFloat(benefitMoneyCollection.reduce((c, p) => c + p).toFixed(2)) : 0;
  return relatedCouponDish;
});
/**
 * 计算实际可用的优惠券的数量
 */
exports.getCouponsLength = (couponsList, privateRoom, serviceProps, orderedDishesProps) => {
  if (privateRoom) {
    return couponsList.length;
  }

  let couponLength = 0;

  couponsList.forEach(coupon => {
    const { fullValue = 0, orderAccount = 0 } = coupon;

    if (fullValue > orderAccount) {
      return false;
    }

    if (coupon.coupDishBeanList.length) {
      if (getRelatedToDishCouponProps(coupon.coupDishBeanList[0], serviceProps, orderedDishesProps).name) {
        couponLength = couponLength + 1;
      }
    } else if (coupon.coupRuleBeanList.length) {
      couponLength = couponLength + 1;
    } else if (coupon.weixinValue) {
      couponLength = couponLength + 1;
    }
  });

  return couponLength;
};

/**
 * 实际优惠的钱
 */
exports.getDishBenefitPrice = (dish, serviceProps, dishes, isHDL) => {
  let dishBenefitPrice = 0;
  const { activityBenefit, wholeOrderBenefit } = serviceProps;
  const { privilegePrices } = activityBenefit;
  // 针对海底捞活动优惠中选择最大优惠价
  const { activityBenefitMaxId, activityBenefitMaxValue } = getActivityBenefitMaxId(dishes);

  // 整单优惠权重分配金额,针对每道菜减去了多少钱
  if (wholeOrderBenefit && wholeOrderBenefit.isChecked && privilegePrices) {
    if (privilegePrices.hasOwnProperty(dish.id)) {
      dishBenefitPrice = privilegePrices[dish.id].prices.reduce((c, p) => c + p);
    }
    return dishBenefitPrice;
  }

  // 单商品会员价
  const isSupportMemberPrice = dish.isMember && !dish.noUseDiscount;
  if (isSupportMemberPrice) {
    dishBenefitPrice = countMemberPrice(true, Immutable.from([dish]), serviceProps.discountProps);
    if (isHDL && dish.id === activityBenefitMaxId) {
      dishBenefitPrice += activityBenefitMaxValue;
    }
    return dishBenefitPrice;
  }
  // 单商品营销
  if (isHDL) {
    if (dish.activityBenefit || (dish.order instanceof Array && dish.order[0].activityBenefit)) {
      // 当外面reduce遍历到当前菜品id和最大优惠id相等情况下，抛出最大优惠价加入总价计算，否则都返回 0
      dishBenefitPrice = dish.id === activityBenefitMaxId ? activityBenefitMaxValue : 0;
    } else if (dish.order.length) {
      dishBenefitPrice = dish.order.reduce((c, p) => c + (p.activityBenefit || 0), 0);
    }
  } else {
    if (dish.activityBenefit) {
      dishBenefitPrice = dish.activityBenefit;
    } else if (dish.order.length) {
      dishBenefitPrice = dish.order.reduce((c, p) => c + (p.activityBenefit || 0), 0);
    }
  }

  return dishBenefitPrice;
};

/**
 *
 * @param {*} price 需要进位的价格
 * @param {*} mCarryLimit 3七进位时 mCarryLimit = 2,表示看小数点后第2位
 */
exports.threeSevenUp = function(price, mCarryLimit) {
  if (mCarryLimit <= 0) {
    return price;
  }
  const bei = Math.pow(10, mCarryLimit);
  const bei_1 = Math.pow(10, mCarryLimit - 1);
  const bei_2 = Math.pow(10, mCarryLimit + 1);

  const intValue = Math.floor(((price * bei_2) / bei_1) % 10);
  const atom = Math.abs(intValue);
  const a1 = parseInt(atom / 5);
  const a2 = atom % 5 >= 3 ? 5 : 0;
  let after = (a1 * 5 + a2) / bei;
  after = intValue > 0 ? after : -after;
  const before = Math.floor(price * bei_1) / bei_1;
  const bbb = (before * bei_2 + after * bei_2) / bei_2;
  const numArr = bbb.toString().split('.');
  const zs = numArr[0];
  const xs = numArr[1] ? numArr[1].substr(0, mCarryLimit) : '';
  const arr = [zs, xs];
  return +arr.join('.');
};

exports.carryPrice = function(carryRuleVO, price) {
  const { transferType, scale } = carryRuleVO;
  const result = { change: 0, price };
  const multiple = Math.pow(10, scale);

  const rule =
    {
      [CarryTypes.ROUND]: () => {
        result.price = +price.toFixed(scale);
      },
      [CarryTypes.CEIL]: () => {
        result.price = Math.ceil(price * multiple) / multiple;
      },
      [CarryTypes.FLOOR]: () => {
        result.price = Math.floor(price * multiple) / multiple;
      },
      [CarryTypes.THREE_SEVEN]: () => {
        result.price = exports.threeSevenUp(price, scale);
      },
    }[transferType] || (() => null);

  rule();

  result.change = +(price - result.price).toFixed(2);
  return result;
};

// 校验收货地址信息
const validateAddressInfo = (exports.validateAddressInfo = (info, isTakeaway, filter, noMobile) => {
  const rules = {
    name: [
      {
        msg: formatMessage(addressText.addressInvalidName),
        validate(value) {
          return !!checkInvalidSymbol(value.trim());
        },
      },
    ],
    sex: [
      {
        msg: formatMessage(actionText.actionselectSex),
        validate(value) {
          const gender = +value;
          return gender === 1 || gender === 0;
        },
      },
    ],
    mobile: [
      {
        msg: formatMessage(orderMessage.orderinputPN),
        validate(value) {
          return !!value.trim();
        },
      },
      // {
      //   msg: '请录入正确的手机号',
      //   validate(value) {
      //     return getPhoneNumberValidate().test(value);
      //   },
      // },
    ],
  };

  if (noMobile) {
    delete rules.mobile;
  }

  if (isTakeaway) {
    Object.assign(rules, {
      baseAddress: [
        {
          msg: formatMessage(addressText.addressselectAddress),
          validate(value) {
            return !!value.trim();
          },
        },
      ],
      street: [
        {
          msg: formatMessage(addressText.addressInvalidStreet),
          validate(value) {
            return !!checkEmojiWith(value.trim());
          },
        },
      ],
    });
  }

  for (const key in rules) {
    if (!rules.hasOwnProperty(key)) {
      continue;
    }

    if (filter && filter(key)) {
      continue;
    }

    const rule = rules[key];
    let value = info[key];

    if (typeof value !== 'number') {
      value = value || '';
    }

    for (let i = 0, len = rule.length; i < len; i++) {
      const item = rule[i];
      const valid = item.validate(value);
      if (!valid) {
        return { valid: false, msg: item.msg };
      }
    }
  }

  return { valid: true, msg: '' };
});

const getSubmitDishData = (exports.getSubmitDishData = (dishesData, shopId_, customerProps = {}) => {
  const result = { singleDishInfos: [], multiDishInfos: [] };
  const { isHDL } = customerProps;
  const getSingleDishInfo = (dishes, func) =>
    [].concat.apply(
      [],
      (dishes || []).map(dish => {
        let dishBenefitPrice = 0;

        if (dish.activityBenefit) {
          dishBenefitPrice = dish.activityBenefit;
        }

        let orderDishes = [];
        const benefitDish = dish.benefitOptions || (Array.isArray(dish.order) && dish.order[0] && dish.order[dish.order.length - 1].benefitOptions) || [];
        const beSelectedBenefit = _find(benefitDish, benefit => benefit.isChecked);
        let priId = dish.isMember ? '0' : null;
        let priType = dish.isMember ? 3 : null; // 会员价的情况
        let priDishNum = 0;

        if (beSelectedBenefit) {
          priId = String(beSelectedBenefit.priId);
          priType = beSelectedBenefit.priType;
          priDishNum = beSelectedBenefit.dishNum;
        } else if (dish.noBenefit) {
          priId = null;
          priType = null;
        }

        if (dish.purchaseBenefit) {
          priId = null;
          priType = null;
        }

        const order = dish.order;
        const dishInfo = {
          num: 0,
          price: dish.marketPrice,
          ingredientIds: [],
          propertyIds: [],
          dishId: dish.id,
          itemId: dish.itemId,
          shopId,
          brandDishId: dish.brandDishId,
          priType,
          priId,
          priDishNum,
          dishName: dish.dishName,
          dishBenefitPrice,
        };

        if (func) {
          func(dishInfo);
        }

        if (typeof order === 'number' && order > 0) {
          dishInfo.num = order;
          dishInfo.priId = (priId && String(priId)) || null;
          dishInfo.priType = priType;

          if (dish.dishPropertyTypeInfos && dish.dishPropertyTypeInfos.length > 0) {
            (dish.dishPropertyTypeInfos || []).forEach(item => {
              [].push.apply(dishInfo.propertyIds, (item.properties || []).filter(subItem => subItem.isChecked || item.type === 4).map(subItem => subItem.id));
            });
          }

          orderDishes.push(dishInfo);
        } else if (Array.isArray(order) && order.length) {
          const orderPrices = [];
          const orderNum = [];
          order.forEach(item => {
            orderPrices.push(getOrderPrice(dish, item));
            orderNum.push(item.count);
          });

          let maxOrderPrice = orderPrices[0];

          for (let i = 1; i < orderPrices.length; i++) {
            if (maxOrderPrice < orderPrices[i]) maxOrderPrice = orderPrices[i];
          }

          let maxCount = orderNum[0];

          for (let i = 1; i < orderNum.length; i++) {
            if (maxCount < orderNum[i]) maxCount = orderNum[i];
          }

          let relatedPrivilege = false;

          orderDishes = order.map(orderDish => {
            const duplicateDishInfo = Object.assign({}, dishInfo, {
              dishBenefitPrice: orderDish.activityBenefit,
            });
            duplicateDishInfo.num = orderDish.count;
            duplicateDishInfo.ingredientIds = (orderDish.dishIngredientInfos || []).filter(item => item.isChecked).map(item => item.id);
            duplicateDishInfo.propertyIds = [];

            (orderDish.dishPropertyTypeInfos || []).forEach(item => {
              [].push.apply(duplicateDishInfo.propertyIds, (item.properties || []).filter(subItem => subItem.isChecked).map(subItem => subItem.id));
            });

            const dishInfoWithPriId =
              (beSelectedBenefit && beSelectedBenefit.type === 1 && !relatedPrivilege) ||
              (beSelectedBenefit && beSelectedBenefit.type === 2 && !relatedPrivilege) ||
              (beSelectedBenefit && beSelectedBenefit.priType === 2 && orderDish.hasGiftBenefit);

            if (dishInfoWithPriId) {
              Object.assign(duplicateDishInfo, {
                priId: String(priId),
                priType,
                priGiftId: [],
              });
              relatedPrivilege = true;
            } else {
              duplicateDishInfo.priId = duplicateDishInfo.priType = null;
            }

            if (!beSelectedBenefit && dish.isMember && !dish.noBenefit) {
              duplicateDishInfo.priId = String(priId);
              duplicateDishInfo.priType = priType;
            }

            return duplicateDishInfo;
          });
        }

        return orderDishes.filter(orderDish => orderDish.num > 0);
      }),
    );

  if (isHDL) {
    result.singleDishInfos = getSingleDishInfo(dishesData.filter(dish => dish.type === 0))
      .reduce((itemList, itemNext) => {
        const itemNextAsMutable = Immutable.isImmutable(itemNext) ? itemNext.asMutable() : { ...itemNext };
        const { dishBenefitPrice: curDishBenefitPrice, priType: curPriType, priDishNum: curPriDishNum } = itemNextAsMutable; // 当前但商品优惠

        if (!curDishBenefitPrice || curPriType !== 1 || curPriDishNum !== 1) {
          // 未使用优惠
          return itemList.concat(itemNextAsMutable);
        }

        itemList.forEach(item => {
          const { dishBenefitPrice: oriDishBenefitPrice, priType: oriPriType, priDishNum: oriPriDishNum } = item;

          if (!oriDishBenefitPrice || oriPriType !== 1 || oriPriDishNum !== 1) {
            return;
          }

          if (curDishBenefitPrice >= oriDishBenefitPrice) {
            Object.assign(item, { priId: null, priType: null });
          } else {
            Object.assign(itemNextAsMutable, { priId: null, priType: null });
          }
        });
        return itemList.concat(itemNextAsMutable);
      }, [])
      .map(item => {
        delete item.dishBenefitPrice;
        delete item.priDishNum;
        return item;
      });
  } else {
    result.singleDishInfos = getSingleDishInfo(dishesData.filter(dish => dish.type === 0)).map(item => {
      const itemAsMutable = Immutable.isImmutable(item) ? item.asMutable() : { ...item };

      delete itemAsMutable.dishBenefitPrice;
      delete itemAsMutable.priDishNum;
      return itemAsMutable;
    });
  }

  const relatedMuilPrivilege = {};

  result.multiDishInfos = [].concat.apply(
    [],
    dishesData
      .filter(dish => dish.type === 1)
      .map(dish => {
        const orderDishes = [];
        const benefitDish = dish.benefitOptions || (dish.order[0] && dish.order[dish.order.length - 1].benefitOptions) || [];
        const beSelectedBenefit = _find(benefitDish, benefit => benefit.isChecked);
        let priId = beSelectedBenefit ? String(beSelectedBenefit.priId) : null;
        let priType = beSelectedBenefit ? beSelectedBenefit.priType : null;

        if (!beSelectedBenefit && !dish.noBenefit && dish.isMember) {
          priId = '0';
          priType = 3;
        }

        if (dish.purchaseBenefit) {
          priId = null;
          priType = null;
        }

        const dishInfo = {
          num: 0,
          price: dish.marketPrice,
          priId,
          priType,
          dishId: dish.id,
          itemId: dish.itemId,
          subDish: [],
          shopId,
          brandDishId: dish.brandDishId,
        };

        (dish.order || []).forEach(orderDish => {
          if (!orderDish.count) {
            return;
          }

          if (relatedMuilPrivilege[dish.brandDishId] && priType === 1) {
            Object.assign(dishInfo, { priId: null, priType: null });
          }

          const duplicateDishInfo = Object.assign({}, dishInfo, {
            num: orderDish.count,
            subDish: [],
          });

          if (!relatedMuilPrivilege[duplicateDishInfo.brandDishId]) {
            relatedMuilPrivilege[duplicateDishInfo.brandDishId] = true;
          }

          (orderDish.groups || []).forEach(group => {
            [].push.apply(
              duplicateDishInfo.subDish,
              getSingleDishInfo(group.childInfos, info => {
                const _info = info;
                _info.groupId = group.id;
              }),
            );
          });

          orderDishes.push(duplicateDishInfo);
        });

        return orderDishes;
      }),
  );

  return result;
});

const filterChosenDish = (exports.filterChosenDish = (dishes, benefitProp, marketUseCoupon, status) => {
  const newDishes = dishes.asMutable({ deep: true });

  newDishes
    .filter(dish => {
      if (dish.benefitOptions) {
        return dish;
      } else if (dish.order[0] && dish.order[dish.order.length - 1].benefitOptions) {
        return dish;
      }

      return false;
    })
    .map(dish => {
      (dish.benefitOptions || dish.order[dish.order.length - 1].benefitOptions).forEach(benefit => {
        if (benefitProp.dishId === dish.brandDishId && benefit.priId === benefitProp.priId) {
          benefit.isChecked = true;

          if (status) {
            benefit.isChecked = false;
          }

          dish.noUseDiscount = true;
          dish.noBenefit = false;
          let reduce = 0;
          let num = 1;
          let benefitDishNum = 1;
          let averageReduce = 0;

          if (benefitProp.type === 1) {
            reduce = benefitProp.reduce;
            num = benefitProp.dishNum;
            benefitDishNum = benefitProp.dishNum;
            averageReduce = Math.min(reduce / num, dish.marketPrice);
          } else if (benefitProp.type === 2) {
            reduce = (1 - benefitProp.discount / 10) * dish.marketPrice * benefitProp.dishNum;
            num = benefitProp.dishNum;
            benefitDishNum = benefitProp.dishNum;
          }

          if (benefitProp.priType === 1) {
            if (dish.benefitOptions) {
              const activeBenefitNum = Math.min(dish.order, num);

              dish.activityBenefit = {
                1: Math.min(dish.marketPrice * activeBenefitNum, reduce),
                2: Math.min(dish.marketPrice * (1 - benefitProp.discount / 10) * activeBenefitNum, reduce),
              }[benefitProp.type];

              dish.activityBenefitNum = activeBenefitNum;
            } else {
              dish.order.forEach(item => {
                item.activityBenefit = 0;
                item.activityBenefitNum = 0;
                const activeBenefitNum = Math.max(Math.min(item.count, benefitDishNum), 0);
                const eachOrderPrice = {
                  1: averageReduce * activeBenefitNum,
                  2: dish.marketPrice * (1 - benefitProp.discount / 10) * activeBenefitNum,
                }[benefitProp.type];

                if (benefitDishNum > 0) {
                  if (eachOrderPrice >= reduce) {
                    item.activityBenefit = Math.min(reduce, eachOrderPrice);
                    item.activityBenefitNum = activeBenefitNum;
                    reduce = 0;
                  } else {
                    item.activityBenefit = eachOrderPrice;
                    item.activityBenefitNum = activeBenefitNum;
                    reduce = reduce - eachOrderPrice;
                  }
                } else {
                  item.activityBenefit = 0;
                }

                benefitDishNum = Math.min(benefitDishNum - 1, benefitDishNum - item.count); // 限定份数
              });
            }
          }
        } else if (benefitProp.dishId === dish.brandDishId) {
          benefit.isChecked = false;
        }
      });

      return dish;
    });

  return newDishes;
});

const reorganizedActivityBenefit = (exports.reorganizedActivityBenefit = (activityBenefit, dishes, benefitProp, marketUseCoupon) => {
  const newDishes = filterChosenDish(dishes, benefitProp);
  const marketUseCouponPrice = filterChosenDish(dishes, benefitProp, marketUseCoupon);
  const newActivityBenefit = activityBenefit.asMutable({ deep: true });

  if (benefitProp.priType === 1) {
    newActivityBenefit.benefitMoney += benefitProp.reduce;
  }

  return {
    dishes: newDishes,
    activityBenefit: newActivityBenefit,
    marketUseCouponPrice,
  };
});

/**
 * 活动优惠菜品选择会员价 或者不选择任何优惠
 */
exports.setDishBenefitInfo = (chosenDish, dish, benefitType) => {
  if (chosenDish.id !== dish.id) {
    return dish;
  }

  const newDish = dish.asMutable({ deep: true });
  newDish.noBenefit = benefitType === 'noBenefit';
  newDish.noUseDiscount = benefitType === 'purchaseBenefit' || benefitType === 'noBenefit';
  newDish.purchaseBenefit = benefitType === 'purchaseBenefit';

  if (newDish.benefitOptions || (newDish.order[0] && newDish.order[newDish.order.length - 1].benefitOptions)) {
    if (isSingleDishWithoutProps(newDish)) {
      newDish.activityBenefit = 0;
      newDish.benefitOptions.forEach(benefit => {
        benefit.isChecked = false;
      });
    } else {
      newDish.activityBenefit = 0;
      newDish.order.forEach(order => {
        order.activityBenefit = 0;
      });

      newDish.order[newDish.order.length - 1].benefitOptions.forEach(benefit => {
        benefit.isChecked = false;
      });
    }
  }

  return newDish;
};

const countAcvitityMoney = (exports.countAcvitityMoney = dishes => {
  const acvitityCollection = [];

  dishes
    .filter(dish => dish.benefitOptions || (dish.order[0] && dish.order[dish.order.length - 1].benefitOptions))
    .forEach(dish => {
      let dishAcvitityCollection = [];

      if (isSingleDishWithoutProps(dish)) {
        dishAcvitityCollection.push(dish.activityBenefit || 0);
      } else {
        dish.order.forEach(order => {
          dishAcvitityCollection.push(order.activityBenefit || 0);
        });

        if (dish.activityBenefit) {
          dishAcvitityCollection.push(dish.activityBenefit * dish.order.length);
        }
      }

      if (parseFloat(dishAcvitityCollection.reduce((c, p) => c + p).toFixed(2)) > getDishPrice(dish)) {
        dishAcvitityCollection = [];
        dishAcvitityCollection.push(getDishPrice(dish));
      }

      for (let i = 0; i < dishAcvitityCollection.length; i++) {
        acvitityCollection.push(dishAcvitityCollection[i]);
      }
    });

  return acvitityCollection.length ? parseFloat(acvitityCollection.reduce((c, p) => c + p).toFixed(2)) : 0;
});

/**
 * 为已点菜品添加对应的优惠选项
 */
const addBenefitTodish = (exports.addBenefitTodish = (benefitProps, dish, dishes, hasPriviledge) => {
  let orderedDish = dish.asMutable({ deep: true });

  /**
   * 如果是加菜模式 已经有优惠
   */
  if (hasPriviledge) {
    return Array.isArray(orderedDish) ? orderedDish[0] : orderedDish;
  }

  (benefitProps.dishPriList || []).forEach(benefit => {
    if (benefit.dishId === orderedDish.brandDishId) {
      benefit.dishPriInfo.forEach(info => {
        info.id = info.priId;
        info.dishId = orderedDish.brandDishId;
      });

      if (Array.isArray(orderedDish.order)) {
        const hasGiftCoupon = _find(benefit.dishPriInfo, info => info.priType === 2);

        if (hasGiftCoupon) {
          const hasMoreCountDish = getDishesPrice(dishes) >= hasGiftCoupon.fullValue;
          /**
           * 表面有复合礼品券优惠的菜品
           */
          if (hasMoreCountDish) {
            orderedDish.order[orderedDish.order.length - 1].benefitOptions = benefit.dishPriInfo;
          } else {
            orderedDish.order[orderedDish.order.length - 1].benefitOptions = (benefit.dishPriInfo || []).filter(info => info.priType !== 2);
          }
        } else {
          orderedDish.order[orderedDish.order.length - 1].benefitOptions = benefit.dishPriInfo;
        }

        if (!orderedDish.isMember) {
          const lastOrderDish = orderedDish.order[orderedDish.order.length - 1];

          if (Array.isArray(lastOrderDish.benefitOptions) && lastOrderDish.benefitOptions.length > 0) {
            lastOrderDish.benefitOptions[0].isChecked = true;
          }

          orderedDish = filterChosenDish(Immutable.from([orderedDish]), orderedDish.order[orderedDish.order.length - 1].benefitOptions[0]);
        }
      } else {
        const hasGiftCoupon = _find(benefit.dishPriInfo, info => info.priType === 2);

        if (hasGiftCoupon) {
          if (getDishesPrice(dishes) >= hasGiftCoupon.fullValue) {
            orderedDish.benefitOptions = benefit.dishPriInfo;
          } else {
            orderedDish.benefitOptions = (benefit.dishPriInfo || []).filter(info => info.priType !== 2);
          }
        } else {
          orderedDish.benefitOptions = benefit.dishPriInfo;
        }

        if (!orderedDish.isMember) {
          if (Array.isArray(orderedDish.benefitOptions) && orderedDish.benefitOptions.length > 0) {
            orderedDish.benefitOptions[0].isChecked = true;
          }

          orderedDish = filterChosenDish(Immutable.from([orderedDish]), orderedDish.benefitOptions[0]);
        }
      }
    }
  });

  return Array.isArray(orderedDish) ? orderedDish[0] : orderedDish;
});

exports.countInitializeBenefit = (benefitProps, dishes, hasPriviledge) => {
  const newOrderedDishes = dishes.asMutable({ deep: true });
  const dishCollection = [];

  for (let i = 0; i < newOrderedDishes.length; i++) {
    const dish = addBenefitTodish(benefitProps, Immutable.from(newOrderedDishes[i]), dishes, hasPriviledge);
    dishCollection.push(dish);
  }

  return countAcvitityMoney(dishCollection);
};

/**
 * getActivityBenefitShared
 * @param {object} objParam
 */
export const getActivityBenefitShared = objParam => {
  const { benefitProps, orderedDishes, needAddBenefit, hasPriviledge } = objParam;
  const newOrderedDishes = orderedDishes.asMutable({ deep: true });
  let activityBenefitShared = true;

  for (let i = 0; i < newOrderedDishes.length; i++) {
    const dish = needAddBenefit ? addBenefitTodish(benefitProps, Immutable.from(newOrderedDishes[i]), newOrderedDishes, hasPriviledge) : newOrderedDishes[i];
    let checkedBenefit = [];

    if (dish.order instanceof Array && dish.order.length) {
      checkedBenefit = (dish.order[dish.order.length - 1].benefitOptions || []).filter(item => item.isChecked && item.shared === false);
    } else if (typeof dish.order === 'number' && dish.benefitOptions) {
      checkedBenefit = (dish.benefitOptions || []).filter(item => item.isChecked && item.shared === false);
    }

    if (checkedBenefit.length) {
      activityBenefitShared = false;
      break;
    }
  }

  return activityBenefitShared;
};

/**
 * 针对已有的单品优惠函数再封装一层，获取加价购是否互斥的逻辑
 */
exports.getPurchaseAndBenefitShared = params => {
  const { serviceProps, orderedDishes } = params;
  let activityBenefitShared = removePurchaseAndDishPriviege(serviceProps, orderedDishes);

  activityBenefitShared = getActivityBenefitShared(params);

  return activityBenefitShared;
};

/**
 * 计算附加费（正餐）
 */
exports.countExtraPrivilege = privilegeArray => {
  if (!privilegeArray) {
    return false;
  }

  const benefitCollection = [];

  privilegeArray.forEach(privilege => {
    benefitCollection.push(+privilege.privilegeAmount);
  });

  return benefitCollection.length ? parseFloat(benefitCollection.reduce((c, p) => c + p).toFixed(2)) : 0;
};

exports.combineAddPrivilege = (addPrivilege, addPrivilegeFromShop, peopleCount, orderedDishesProps) => {
  const copyAddPrivilegeFromShop = clonedeep(addPrivilegeFromShop || []).filter(item => !item.serviceCharge);
  const serviceFromShop = clonedeep(addPrivilegeFromShop || []).filter(item => item.serviceCharge)[0] || {};
  const copyAddPrivilege = clonedeep(addPrivilege || []).filter(item => item.promoId !== serviceFromShop.id);

  const originPrice = getDishesPrice(orderedDishesProps);
  let addPrivilegeList = [];

  if (!copyAddPrivilegeFromShop || copyAddPrivilegeFromShop.length === 0) {
    return copyAddPrivilege;
  }

  copyAddPrivilegeFromShop.forEach((item, index) => {
    let extraPrice = 0;

    switch (item.calcWay) {
      case CalcWay.DISCOUNT: // 折扣
        extraPrice += (item.content / 100) * originPrice;
        break;
      case CalcWay.PEOPLE: // 人数
        extraPrice += peopleCount * item.content;
        break;
      case CalcWay.REGULAR: // 固定金额
        extraPrice += item.content;
        break;
      case CalcWay.STAGE:
        extraPrice += calcStageFee(originPrice, item.sections);
        break;
      default:
        break;
    }

    item.privilegeAmount = parseFloat(extraPrice.toFixed(2));
    item.privilegeName = item.name;
    item.promoId = item.id;
  });

  addPrivilegeList = addPrivilegeList.concat(copyAddPrivilegeFromShop);

  /**
   * 合并 addPrivilege 以及 addPrivilegeFromShop
   */
  (copyAddPrivilege || []).forEach((item, index) => {
    let include = false;

    copyAddPrivilegeFromShop.forEach((itemt, indext) => {
      if (itemt.promoId === item.promoId) {
        include = true;
      }
    });

    if (!include) {
      addPrivilegeList.push(item);
    }
  });

  return addPrivilegeList;
};

exports.getMultiDishPrivilegeInfoDishList = detail => {
  const dishList = detail.dishList || [];
  const applyProductType = detail.applyProductType;

  if (!dishList || dishList.length === 0) {
    return {
      detailDishIdList: [],
      rangeStatus: { applyProductType, range: '' },
    };
  }

  const detailDishIdList = [];
  let range = '';

  const innerListCount = (dishItem, bool) => {
    switch (dishItem.productDishType) {
      case 1: {
        // 中类
        let productDishTypeOne = '';
        productDishTypeOne += `${dishItem.dishTypeName}(`;

        if (dishItem.dishList && dishItem.dishList.length > 0) {
          dishItem.dishList.forEach((item, index) => {
            productDishTypeOne += innerListCount(item, false);
            detailDishIdList.push(item.dishId); // 把中类下的菜ID加上
          });
        }

        return productDishTypeOne.substring(0, productDishTypeOne.length - 1) + ')，';
      }
      case 2: {
        // 菜品
        let productDishTypeTwo = '';

        if (bool) {
          productDishTypeTwo += `${dishItem.dishName},`;
        } else {
          return `${dishItem.dishName},`;
        }

        detailDishIdList.push(dishItem.dishId);

        return productDishTypeTwo;
      }
      default:
        break;
    }
  };

  dishList.forEach((item, index) => {
    range = range + innerListCount(item, true);
  });

  return {
    detailDishIdList,
    rangeStatus: {
      applyProductType,
      range: range.substring(0, range.length - 1),
    },
  };
};

exports.setMarketUseCouponList = (marketUseCouponList, id, addItem) => {
  const obj = Object.assign({}, marketUseCouponList);
  obj[id] = addItem;

  return obj;
};

const sortDishPrivilegeList = dishPriInfo => {
  if (!dishPriInfo || !dishPriInfo.length) {
    return dishPriInfo || [];
  }

  return dishPriInfo
    .map(item => {
      const { type: dishPriType, discount, reduce } = item;
      const isDiscount = dishPriType === CouponPrivTypes.DISCOUNT;

      return {
        ...item,
        _sort: isDiscount ? Math.pow(10, 10) + (10 - discount) : reduce,
      };
    })
    .sort((prev, next) => next._sort - prev._sort);
};

exports.initActivityBenefitList = (obj, dishes) => {
  const itemList = [];

  obj.forEach((item, index) => {
    item.dishPriInfo.forEach((itemt, indext) => {
      if (itemt.priType === 2 && itemt.isChecked === true) {
        itemList.push({ id: itemt.dishId, info: itemt });
      }
    });
    item.dishPriInfo = sortDishPrivilegeList(item.dishPriInfo);
  });

  return itemList;
};

exports.setInitMarketUseCouponList = (obj, activityBenefit, dishes, itemList) => {
  const marketUseCouponObj = {};

  (itemList || []).forEach((item, index) => {
    const marketUseCouponPrice = reorganizedActivityBenefit(activityBenefit, dishes, item.info, true).marketUseCouponPrice;

    marketUseCouponObj[item.id] = marketUseCouponPrice;
  });

  return marketUseCouponObj;
};

exports.addOrderAccountToCoupon = (couponList = [], orderAccount) => {
  couponList.forEach(item => {
    const { fullValue = 0 } = item;
    const diffAmount = +(fullValue - orderAccount).toFixed(2);

    Object.assign(item, { orderAccount, diffAmount });
  });

  couponList.sort((prev, next) => prev.diffAmount - next.diffAmount);
};

/**
 * get timejson between startTime and endTime.
 * @param {Date} startTime
 * @param {Date} startTime
 */
exports.getLaterTime = (startTime = new Date(), endTime = new Date()) => {
  const timeObject = {};
  const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

  let startHour = startTime.getHours();
  const endHour = endTime.getHours();
  const endMinute = endTime.getMinutes();

  let startMinute = (function() {
    let tmp = Math.ceil(startTime.getMinutes() / 10) * 10;
    if (startTime.getMinutes() % 10 === 0) {
      tmp += 10;
    }

    if (tmp >= 60) {
      startHour = (startHour + 1) % 24;
      tmp = 0;
    }

    return tmp;
  })();

  startMinute = startMinute < 10 ? '00' : startMinute.toString();

  for (let i = 0; startHour + i < 24 && (startHour + i) % 24 <= endHour; i++) {
    const j = (startHour + i) % 24;

    if (j === startHour && startHour === endHour) {
      timeObject[j] = minutes.filter(val => val >= startMinute && val <= endMinute);
    } else if (j === startHour) {
      timeObject[j] = minutes.filter(val => val >= startMinute);
    } else if (j === endHour) {
      timeObject[j] = minutes.filter(val => val <= endMinute);
    } else {
      timeObject[j] = minutes;
    }

    if (timeObject[j].length === 0) {
      delete timeObject[j];
    }
  }

  return timeObject;
};

/**
 * 是否菜品礼品券
 * @param {object} coupon
 */
const isDishGiftCoupon = (exports.isDishGiftCoupon = function(coupon) {
  const { coupDishBeanList, couponType } = coupon;

  return couponType === CouponTypes.GIFTVALUE && coupDishBeanList && coupDishBeanList.length > 0;
});

const getCardCodeAndCouponIds = (exports.getCardCodeAndCouponIds = (currentCouponsDetail = []) => {
  const result = {
    coupons: [],
    cardCodes: [],
    weixinGiftId: '',
    giftDishCoupons: [],
  };
  const { coupons, giftDishCoupons } = result;
  const weixinCards = [];

  currentCouponsDetail.forEach(coupon => {
    const { id, weixinValue } = coupon;
    // 菜品礼品券
    if (isDishGiftCoupon(coupon)) {
      giftDishCoupons.push(id);
    }

    // 微信礼品券
    if (weixinValue) {
      weixinCards.push(coupon);
    }

    // 筛选除了菜品礼品券之外的券
    if (!giftDishCoupons.some(item => item === id)) {
      coupons.push({
        couponId: id,
        couponType: weixinValue ? CouponSubmitDataTypes.WECHAT : CouponSubmitDataTypes.SYSTEM,
      });
    }
  });

  result.cardCodes = weixinCards.map(item => item.codeNumber);

  return result;
});

exports.amendSubmitCouponData = function(coupons, { singleDishInfos, multiDishInfos }, giftCouponToDishRelations) {
  const ret = {
    coupons: [],
  };
  const giftDishCoupons = [];

  coupons.forEach(coupon => {
    const { coupDishBeanList, id, weixinValue } = coupon;

    if (isDishGiftCoupon(coupon)) {
      const [first] = coupDishBeanList;
      giftDishCoupons.push({ id, dishId: first.dishId });
    } else {
      ret.coupons.push({
        couponId: id,
        couponType: weixinValue ? CouponSubmitDataTypes.WECHAT : CouponSubmitDataTypes.SYSTEM,
      });
    }
  });

  if (!giftDishCoupons.length) {
    return ret;
  }

  const relateCouponIdToDish = dishData => {
    const matchedCouponIds = (giftCouponToDishRelations[dishData.dishId] || []).shift();

    if (matchedCouponIds) {
      return Object.assign(dishData, { priGiftId: matchedCouponIds });
    }

    return dishData;
  };

  if (singleDishInfos && singleDishInfos.length) {
    singleDishInfos.forEach((dishProp, index) => {
      const dishData = Immutable.from(dishProp).asMutable({ deep: true });
      singleDishInfos[index] = relateCouponIdToDish(dishData);
    });
  }

  if (multiDishInfos && multiDishInfos.length) {
    multiDishInfos.forEach((dishProp, index) => {
      const dishData = Immutable.from(dishProp).asMutable({ deep: true });
      multiDishInfos[index] = relateCouponIdToDish(dishData);
    });
  }

  return ret;
};

const getPayMethod = selectedPayMethod => {
  const payMethodScope = selectedPayMethod.id === 'online-payment' ? PayWay.ONLINE : PayWay.OFFLINE;

  return payMethodScope;
};

exports.getSubmitUrlParams = (state, note, receipt, sellType, consumePassword, taxIdentyNo, scanTableId, isHDL, tableware) => {
  const { orderedDishesProps, serviceProps, commercialProps, customerProps, tableProps, selectedPayMethod, orderMemo } = state;
  const dishes = orderedDishesProps.dishes;
  const tableIdFromQRCode = sessionStorage.getItem('tableId');
  const { memberPoint, real: needPayPrice } = chargeCalcaltor.calc(orderedDishesProps, serviceProps, commercialProps, void 0, isHDL);
  const integral = serviceProps.integralsInfo && serviceProps.integralsInfo.isChecked ? memberPoint.integralInUsed : 0;
  const payMethodScope = getPayMethod(selectedPayMethod);
  const sourceChild = getUrlParam('hdlScence') || getParamFromSession('hdlScence') || window.navigator.userAgent;
  const { currentCouponsDetail } = serviceProps.couponsProps;
  const useDiscount = !serviceProps.discountProps.inUseDiscount ? 0 : 1;
  const serviceApproach = serviceProps.isPickupFromFrontDesk && serviceProps.isPickupFromFrontDesk.isChecked ? 'pickup' : 'totable';
  const { cardCodes } = getCardCodeAndCouponIds(currentCouponsDetail);
  const tables = tableProps.tables || [];

  if (commercialProps.inputSnackTableCount === 2 && !customerProps.customerCount && serviceApproach === 'totable') {
    return { success: false, msg: formatMessage(orderMessage.orderSelectDinnerPeople) };
  }

  // 号牌模式，前台自取，公众号进入，没有tableId，需要选桌台
  if (!tableIdFromQRCode && commercialProps.numberPlateModel && serviceApproach === 'pickup') {
    if (tables.filter(table => table.isChecked).length === 0) {
      return { success: false, msg: formatMessage(orderMessage.orderUnSelectPlate) };
    }
  }

  let tableId;
  if (type === 'TS' && tableIdFromQRCode) {
    if (serviceApproach && serviceApproach.indexOf('pickup') !== -1) {
      tableId = 0;
    } else {
      tableId = tableIdFromQRCode;
    }
  } else if (type === 'TS' && serviceApproach === 'totable' && tables.length) {
    if (scanTableId) {
      tableId = scanTableId;
    } else if (tables.filter(table => table.isChecked).length === 0) {
      return serviceProps.serviceApproach.indexOf('pickup') !== -1 && serviceProps.serviceApproach.indexOf('totable') === -1
        ? { success: false, msg: formatMessage(orderMessage.orderOpenSelfGetSwitch) }
        : { success: false, msg: formatMessage(orderMessage.orderUnSelectTableInfo) };
    } else {
      tableId = tables.filter(table => table.isChecked)[0].synFlag;
    }
  } else if ((type === 'TS' && serviceApproach && serviceApproach.indexOf('pickup') !== -1) || type === 'WM') {
    tableId = 0;
  } else {
    return { success: false, msg: formatMessage(orderMessage.ordernoTablePrompt) };
  }
  const newSourceChild = getBrowserCode(sourceChild);
  const params = {
    shopId,
    useDiscount,
    memo: note,
    needPayPrice,
    payMethod: payMethodScope,
    invoice: receipt,
    consumePassword,
    taxIdentyNo,
    sourceChild: newSourceChild,
  };

  if (serviceProps.couponsProps.privateRoom) {
    params.yaZuoIntegral = Number(integral);
  } else {
    params.integral = Number(integral);
  }

  Object.assign(params, getSubmitDishData(dishes || [], parseInt(params.shopId, 10) || 0, customerProps));

  // if (payMethodScope === '1' && cardCodes.length) {
  // 要让 快餐和外卖不走这条线 snail
  if ((type === 'WM' || !isFormalMeal(commercialProps.diningForm)) && payMethodScope === '1' && cardCodes.length) {
    return needPayPrice === 0
      ? {
          success: false,
          msg: `${formatMessage(activateText.activateCardSorry)}，${sessionStorage.getItem('currency')}0${formatMessage(orderMessage.orderCannotUseWXCard)}`,
        }
      : { success: false, msg: formatMessage(orderMessage.orderCannotUsePrompt) };
  }

  if (type === 'WM') {
    const sendAreaId = state.serviceProps.sendAreaId === -1 ? 0 : state.serviceProps.sendAreaId;
    const selectedDateTime =
      sellType === 'ws'
        ? state.timeProps.onlyPromptlyDelivery === 1
          ? { date: '', time: '' }
          : state.timeProps.selectedDateTime
        : state.timePropsZt.selectedDateTime;
    let selectedAddress = null;
    let isSelfFetch = false;

    // 设置餐具数量
    if (isHDL && tableware === 0) {
      params.memo = `无需餐具${note.length ? '，' : ''}${note}`;
    }

    // 只要是海底捞外卖就传这个参数
    if (isHDL) {
      params.dinnerwareNum = tableware || 0;
    }

    if (sellType === 'zt' && !selectedDateTime.date) {
      return { success: false, msg: formatMessage(orderMessage.orderNoUseableShopTime) };
    }

    if (state.customerProps.addresses instanceof Array && state.customerProps.addresses.length) {
      selectedAddress = state.customerProps.addresses.find(address => address.isChecked);
    }

    if (!selectedAddress && sellType === 'ws') {
      return { success: false, msg: formatMessage(addressText.addressselectAddress) };
    } else if (selectedAddress && sellType === 'ws') {
      if (!state.timeProps.selectedDateTime.time) {
        if (state.timeProps.onlyPromptlyDelivery !== OnlyPromptlyDelivery.OPEN) {
          // 未开启尽快送达-且没选时间则提示必须选时间
          return { success: false, msg: formatMessage(addressText.selectDeliveryArriveTime) };
        }
      }
      const validateAddressResult = validateAddressInfo(selectedAddress, true, key => ['baseAddress', 'street'].indexOf(key) !== -1);
      if (!validateAddressResult.valid) {
        return { success: false, msg: validateAddressResult.msg };
      }

      const sex = selectedAddress.sex;
      isSelfFetch = selectedAddress.id === 0;

      if (!selectedDateTime.date && sellType === 'ws' && state.timeProps.onlyPromptlyDelivery === 0) {
        return {
          success: false,
          msg: `${formatMessage(orderMessage.orderHelperSelect)}${
            isSelfFetch ? formatMessage(dinnerDetailText.takeMeal) : formatMessage(orderMessage.orderArrived)
          }${formatMessage(orderMessage.orderHelperTime)}`,
        };
      }

      const toShopFlag = isSelfFetch ? 1 : 0;
      let mobile = selectedAddress.mobile.toString();

      if (mobile.indexOf('4') === 0 && mobile.length === 9) {
        mobile = '0' + mobile;
      }

      const latitude = selectedAddress.latitude || 0;
      const longitude = selectedAddress.longitude || 0;

      Object.assign(params, {
        name: selectedAddress.name,
        nationalCode: selectedAddress.nationalCode,
        mobile,
        sex,
        orderType: 'WM',
        address: isSelfFetch ? '' : selectedAddress.address,
        memberAddressId: String(selectedAddress.id),
        sendAreaId: sellType === 'ws' ? String(sendAreaId) : '',
        toShopFlag,
        latitude,
        longitude,
      });
    }

    if (selectedDateTime.time) {
      params.time = `${selectedDateTime.date} ${selectedDateTime.time}`.trim();
      // 选了立即送达
      if (isNaN(selectedDateTime.time.slice(0, 2) * 1)) {
        params.deliveryArriveTime = moment((moment().unix() + state.timeProps.averageSendTime * 60) * 1000).format('HH:mm');
      } else {
        params.deliveryArriveTime = selectedDateTime.time;
      }
    } else {
      // 开启尽快送达-获取送达时间传给后端用于计算服务费
      if (state.timeProps.onlyPromptlyDelivery === OnlyPromptlyDelivery.OPEN) {
        params.deliveryArriveTime = moment(state.timeProps.preDeliveryTime * 1).format('HH:mm');
      }
    }
  } else {
    const { date, time } = state.timePropsTS.selectedDateTime;
    const sex = +String(state.customerProps.sex) || '';
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const takeMealtime = date && time ? year + '-' + month + '-' + day + ' ' + date + ':' + time : null;

    Object.assign(params, {
      name: state.customerProps.name || '',
      mobile: state.customerProps.mobile,
      sex,
      orderType: 'TS',
      tableId,
      peopleCount: state.customerProps.customerCount,
      serviceApproach,
      takeMealtime,
    });
  }

  // 最后校验订单备注
  if (orderMemo.switchStatus && !note.length) {
    return { success: false, msg: formatMessage(orderMessage.orderMemoIsRequired) };
  }
  return { success: true, params, needPayPrice };
};

/**
 * 下单人数范围
 */
exports.getCustomerRange = customerRange =>
  Array.apply(null, { length: customerRange }).map((item, index) => ({
    id: index + 1,
    name: index + 1,
    isChecked: false,
  }));

/**
 * 获取整单优惠的原则状态
 */
exports.getWholeOrderBenefitWordWithColor = applyProductType => {
  const wholeOrderBenefitWord = {
    [ApplyProductType.ALLPRODUCT]: '所有商品可用',
    [ApplyProductType.PARTPRODUCT]: '部分商品可用',
    [ApplyProductType.NOTPARTPRODUCT]: '部分商品不可用',
  }[applyProductType];
  const checkBenefitWordColor = applyProductType === ApplyProductType.PARTPRODUCT || applyProductType === ApplyProductType.NOTPARTPRODUCT;

  return { wholeOrderBenefitWord, checkBenefitWordColor };
};

/**
 * getmMarketUseCouponPrice 叠加 MarketUseCouponPrice
 */
exports.getmMarketUseCouponPrice = marketUseCouponObj => {
  let marketUseCouponPrice = 0;
  for (const i in marketUseCouponObj) {
    if (marketUseCouponObj[i]) {
      marketUseCouponPrice += Number(marketUseCouponObj[i]);
    }
  }

  return marketUseCouponPrice;
};

const getBenefitTitle = function(
  {
    benefitName,
    benefitType,
    discount, // 打折数
    reduce, // 减免数
    type: typeOfBenefit, // 是满减还是满折(单、多商品促销)
    marketRuleDtos, // 加价购、满赠的规则
    dishNum, // 单品促销需要满足的商品数量 / 限免加料份数
    consumeLimit, // 多商品促销的满额规则
    matched,
    diff, // 计算好的差值
    benefitDishes,
    stackRule,
    freeNum, // 限免多少份
    totalDishCount, // 菜品总份数
  },
  justRule,
  superimpose,
  dishesCount, // 在活动列表内的商品数量
) {
  const fulledText = formatMessage(orderMessage.orderfulled); // 已满
  const dishCountText = formatMessage(dishMenuMessage.dishCount); // 份
  const lessText = formatMessage(orderMessage.less); // 还差
  const canText = formatMessage(orderMessage.can); // 可
  const alreadyText = formatMessage(orderMessage.already); // 已
  const yuanText = formatMessage(orderMessage.yuan); // 元
  const fullText = formatMessage(orderMessage.full); // 满
  const enjoyText = formatMessage(orderMessage.enjoy); // 享
  const reduceText = formatMessage(orderMessage.reduce); // 减
  const discountText = formatMessage(orderMessage.discount); // 折
  const addText = formatMessage(orderMessage.add); // 加
  const chooseText = formatMessage(orderMessage.choose); // 选
  const buyText = formatMessage(orderMessage.yuanBuy); // 元换购商品
  const giftsText = formatMessage(orderMessage.gifts); // 份赠品
  const nextText = formatMessage(orderMessage.next); // 下一份
  const lowestPriceText = formatMessage(orderMessage.lowestPrice); // 最低价
  const everyText = formatMessage(orderMessage.every); // 每
  const limitFreeText = '限免'; // 限免
  const addIngredientText = '加料'; // 加料

  diff = formatPrice(diff);

  let title = '';
  if (benefitType === MEMBER_PRICE) {
    title = benefitName;
  }

  if (benefitType === LIMIT_PROMOTIONS) {
    if (justRule) {
      // 每满 1 份 限免2份加料
      title = `${everyText}${fullText}1${dishCountText}，${limitFreeText}${dishNum}${dishCountText}${addIngredientText}`;
    } else {
      // 已满3份，已限免6份加料
      title = `${fulledText}${totalDishCount}${dishCountText}，${alreadyText}${limitFreeText}${freeNum}${dishCountText}${addIngredientText}`;
    }
  }

  // 单商品只有满量促销
  if (benefitType === SINGLE_PROMOTIONS) {
    const condition = `${dishNum}${dishCountText}`; // 2份
    // 减8元  享1折
    const action = typeOfBenefit === 1 ? `${reduceText}${reduce}${yuanText}` : `${enjoyText}${discount}${discountText}`;
    if (justRule) {
      title = `${fullText}${condition}${action}`; // 满 2份 减8元/享1折
    } else if (matched) {
      title = `${fulledText}${condition}, ${alreadyText}${action}`; // 已满 2份, 已 减8元/享1折
    } else {
      // 满 2份 可 减8元/享1折, 还差 8 份
      title = `${fullText}${condition}${canText}${action}, ${lessText}${diff}${dishCountText}`;
    }
  }

  // 多商品只有满额促销
  if (benefitType === MULTI_PROMOTIONS) {
    const condition = `${consumeLimit}${yuanText}`; // 100元
    // 减100元   享8折
    const action = typeOfBenefit === 1 ? `${reduceText}${reduce}${yuanText}` : `${enjoyText}${discount}${discountText}`;
    if (justRule) {
      title = `${fullText}${condition}${action}`; // 满 100元 减100元/享8折
    } else if (matched) {
      title = `${fulledText}${condition}, ${alreadyText}${action}`; // 已满 100元, 已 减100元/享8折
    } else {
      title = `${fullText}${condition}${action}, ${lessText}${diff}${yuanText}`; // 满 100元 减100元/享8折, 还差 50 元
    }
  }

  // 满额，满量促销都有
  if (benefitType === FULL_PROMOTIONS) {
    const { ruleSubjectId, policySubjectId, logicValue, policyValue1 } = marketRuleDtos[0];
    const chosenDishNum = countDishesNumber(benefitDishes);
    const condition = `${logicValue}${ruleSubjectId === 11 ? dishCountText : yuanText}`;
    const action = policySubjectId === 17 ? `${addText}${policyValue1}${buyText}` : `${chooseText}${chosenDishNum || superimpose || policyValue1}${giftsText}`;
    if (justRule) {
      title = `${fullText}${condition}${canText}${action}`;
    } else if (matched) {
      title = `${fulledText}${condition}, ${chosenDishNum > 0 ? alreadyText : canText}${action}`;
    } else {
      title = `${fullText}${condition}${action}, ${lessText}${diff}${ruleSubjectId === 11 ? dishCountText : yuanText}`;
    }
  }

  if (benefitType === FULL_COUNT_PROMOTIONS) {
    const { logicValue, policyValue1, productType } = marketRuleDtos[0];
    const isSingle = productType === 1;
    // 多商品，可叠加，计算出可以有多少份享受折扣
    const hasBenefitCount = stackRule && dishesCount ? Math.floor(dishesCount / (logicValue + 1)) : 1;
    const conditionValue = (isSingle ? logicValue : logicValue + 1) * (hasBenefitCount || 1);
    const prefix =
      matched && dishesCount >= conditionValue ? `${fulledText}${conditionValue}${dishCountText}` : `${lessText}${isSingle ? diff : diff + 1}${dishCountText}`;
    const suffix = isSingle ? nextText : `${lowestPriceText}${hasBenefitCount || 1}${dishCountText}`;
    const action = matched && dishesCount > logicValue ? alreadyText : canText;

    if (justRule) {
      title = `${stackRule ? everyText : ''}${fullText}${conditionValue}${dishCountText}, ${suffix}${enjoyText}${policyValue1}${discountText}`;
    } else {
      title = `${prefix}, ${suffix}${action}${enjoyText}${policyValue1}${discountText}`;
    }
  }

  return title;
};

exports.getBenefitTitle = getBenefitTitle;

/**
 * 判断加入商品后是否满足优惠
 * @param {*} benefit 优惠实例
 * @param {*} dishes 符合优惠实例规则的商品列表
 */
const isMatchBenefit = function(benefit, dishes) {
  const { benefitType } = benefit;
  const totalPrice = getDishesBasePrice(dishes);
  const totalNum = countDishesNumber(dishes);

  let matched = false;
  let diff = 0;

  if (benefitType === LIMIT_PROMOTIONS) {
    // 限免
    matched = benefit.totalDishCount > 0; // 只要被免价>0 则表示匹配
    diff = 0;
  }

  if (benefitType === MULTI_PROMOTIONS) {
    matched = benefit.consumeLimit <= totalPrice;
    diff = matched ? 0 : benefit.consumeLimit - totalPrice;
  }

  if (benefitType === FULL_PROMOTIONS || benefitType === FULL_COUNT_PROMOTIONS) {
    const { marketRuleDtos } = benefit;
    const { ruleSubjectId, logicValue } = marketRuleDtos[0];
    // ruleSubjectId 11.满额 12.满量
    if ((ruleSubjectId === 11 && totalNum >= logicValue) || (ruleSubjectId === 12 && totalPrice >= logicValue)) {
      matched = true;
    } else {
      diff = logicValue - (ruleSubjectId === 11 ? totalNum : totalPrice);
    }
  }

  if (benefitType === SINGLE_PROMOTIONS) {
    const { dishNum } = benefit;
    matched = totalNum >= dishNum;
    diff = matched ? 0 : dishNum - totalNum;
  }

  if (benefitType === MEMBER_PRICE) {
    matched = true;
  }

  return {
    matched,
    diff,
  };
};

exports.isMatchBenefit = isMatchBenefit;

exports.transformSinglePromotions = list => {
  const allActivities = list.reduce(
    (all, curr) =>
      all.concat(
        curr.dishPriInfo.map(pri => {
          pri.dishId = curr.dishId;
          return pri;
        }),
      ),
    [],
  );

  const uniqList = uniqBy(allActivities, 'planId').map(item => {
    const benefit = {
      ...item,
      benefitKey: item.planId,
      benefitId: item.planId,
      benefitName: item.priName,
      benefitType: SINGLE_PROMOTIONS,
      canUseDishIds: [item.dishId],
      dishKeys: [],
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false,
      // shared: true, // 活动配置
    };

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });

  const discountList = uniqList.filter(item => item.type === 2).sort((a, b) => a.discount - b.discount);
  const reduceList = uniqList.filter(item => item.type === 1).sort((a, b) => b.reduce - a.reduce);

  return reduceList.concat(discountList);
};

// 限免优惠只对非套餐加料有效
const isIngredientDish = dish => {
  const { order, groups, dishIngredientInfos = [] } = dish || {};
  if (typeof order === 'number' || groups) return false;
  return !!dishIngredientInfos.length;
};
// 在所有菜品中筛选出参加限免的菜品（只要某个被选中的配料中包含限免配料dishBrandIds 则默认此菜参加限免活动）
const getLimitDishes = (divideDishes = [], dishBrandIds = [], dishNum = 0) => {
  if (!divideDishes) return {};
  const limitCanUseIdsObj = {};
  let allFree = [];
  let totalDishCount = 0;

  divideDishes.forEach((dish = {}) => {
    const { order } = dish;
    if (!isIngredientDish(dish) || !Array.isArray(order)) return;
    order.forEach((o = {}) => {
      const { count, dishIngredientInfos = [] } = o;
      // 此处item.id -> item.dishBrandId
      const checkedIngredientList = dishIngredientInfos.filter((item = {}) => item.isChecked && dishBrandIds.indexOf(item.dishBrandId) > -1);
      totalDishCount = totalDishCount + (!!checkedIngredientList.length ? count : 0);
      if (!!checkedIngredientList.length) {
        dishIngredientInfos.forEach((item = {}) => {
          // 此处item.id -> item.dishBrandId
          if (item.isChecked && dishBrandIds.indexOf(item.dishBrandId) > -1) {
            limitCanUseIdsObj[dish.key] = true;
            const freeList = Array.from({ length: count }).map(_item => ({ [item.dishBrandId]: item.reprice }));
            allFree.push(...freeList);
          }
        });
      }
    });
  });

  allFree = allFree.sort((a, b) => Object.values(a)[0] - Object.values(b)[0]); // 限免从低价开始
  const shouldFreeNum = totalDishCount * dishNum; // 应该限免的份数
  const freeNum = allFree.length >= shouldFreeNum ? shouldFreeNum : allFree.length; // 实际限免份数
  const reduce = allFree.slice(0, freeNum).reduce((all, curr) => all + Object.values(curr)[0], 0);

  return {
    limitCanUseIds: Object.keys(limitCanUseIdsObj), // 可以使用限免的菜品key
    totalDishCount, // 可使用限免菜品的总份数
    freeNum, // 被减免的加料总份数
    reduce, // 被减免加料的总金额
  };
};
exports.getLimitDishes = getLimitDishes;

// 重新计算限免优惠
exports.reCalLimitFree = state => {
  const {
    divideDishes,
    onSelectBenefitDish: { currentBenefit, dishKey },
    allBenefits,
  } = state;

  const updateKeys = currentBenefit.dishKeys.filter(
    // 当前优惠组内剩下的菜品key
    key => key !== dishKey,
  );
  const currentDishes = divideDishes.filter(
    // 当前优惠组内剩下的菜品
    dish => updateKeys.indexOf(dish.key) > -1,
  );

  const limitPromotion = allBenefits[LIMIT_PROMOTIONS] && allBenefits[LIMIT_PROMOTIONS].length && allBenefits[LIMIT_PROMOTIONS][0];
  if (!limitPromotion) return [];
  const { dishBrandIds, dishNum } = limitPromotion || {};
  const { totalDishCount, freeNum, reduce } = getLimitDishes(currentDishes, dishBrandIds, dishNum);
  return [
    {
      ...limitPromotion,
      dishKeys: updateKeys,
      totalDishCount,
      freeNum,
      reduce,
    },
  ];
};
// 清除groups中所有的优惠商品
exports.clearPromotion = function(state, groups) {
  groups.forEach(bType => {
    state = state.updateIn(['allBenefits', bType], benefits =>
      benefits.flatMap(benefit =>
        benefit.merge(
          bType === LIMIT_PROMOTIONS
            ? {
                totalDishCount: 0,
                freeNum: 0,
                reduce: 0,
                dishKeys: [],
                matched: false,
                conflicted: false,
                diff: 0,
                benefitDishes: [],
              }
            : {
                dishKeys: [],
                matched: false,
                conflicted: false,
                diff: 0,
                benefitDishes: [],
              },
        ),
      ),
    );
  });
  return state;
};

// 限免优惠
exports.transformLimitPromotions = (data = {}, divideDishes = []) => {
  const { planId = '', dishNum = 0, dishBrandIds = [] } = data;
  if (!dishBrandIds.length) return [];
  const { limitCanUseIds, totalDishCount, freeNum, reduce } = getLimitDishes(divideDishes, dishBrandIds, dishNum);
  const benefit = {
    benefitKey: planId,
    benefitId: planId,
    benefitName: '限免',
    benefitType: LIMIT_PROMOTIONS,
    canUseDishIds: [], // 当前所有菜品中能够使用限免优惠的dish id集合
    dishKeys: [],
    matched: false,
    diff: 0, // 如果不满足条件的差值
    conflicted: false,
    shared: true, // 与优惠券可共用
    dishBrandIds,
    limitCanUseIds, // 当前所有菜品中能够使用限免优惠的dish key集合
    totalDishCount, // 参加活动菜品总份数
    dishNum, // 每一份限免份数
    freeNum, // 实际限免份数
    reduce, // 限免后应该减去的总价格
  };
  benefit.benefitRuleText = getBenefitTitle(benefit, true);
  return totalDishCount > 0 ? [benefit] : [];
};

exports.transformMultiPromotions = (list, dishes) => {
  const { ALLPRODUCT, PARTPRODUCT } = ApplyProductType;
  const dishIds = dishes.map(dish => dish.brandDishId);

  const transformedList = list.map(item => {
    const limitDishIds = getDishIds(item.dishList);
    const { applyProductType } = item;
    const canUseDishIds =
      applyProductType === ALLPRODUCT ? dishIds : applyProductType === PARTPRODUCT ? limitDishIds : dishIds.filter(id => limitDishIds.indexOf(id) === -1);
    const benefit = {
      ...item,
      benefitKey: item.planId,
      benefitId: item.planId,
      benefitName: item.ruleName,
      benefitType: MULTI_PROMOTIONS,
      canUseDishIds,
      dishKeys: [],
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false,
      // shared: true, // 活动配置
    };

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });

  const discountList = transformedList.filter(item => item.type === 2).sort((a, b) => a.discount - b.discount);
  const reduceList = transformedList.filter(item => item.type === 1).sort((a, b) => b.reduce - a.reduce);

  return reduceList.concat(discountList);
};

exports.transformFullPromotions = list =>
  list.map(item => {
    const benefit = {
      ...item,
      benefitKey: item.id,
      benefitId: item.id,
      benefitName: item.name,
      benefitType: FULL_PROMOTIONS,
      canUseDishIds: item.activityDishes
        .reduce((total, dish) => (dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish)), [])
        .map(dish => dish.dishId),
      dishKeys: [],
      benefitDishes: [], // 加价购、赠送的商品
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false,
      shared: false, // 目前满额，满量促销与优惠券一定互斥
    };

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });

exports.transformDiscountCards = list =>
  list.map(item => ({
    ...item,
    benefitKey: item.cardNum,
    benefitId: item.cardNum,
    benefitName: item.cardKindName,
    benefitType: DISCOUNT_CARDS,
    canUseDishIds: [], // 暂时为所有商品适用
    dishKeys: [],
    matched: false,
    diff: 0,
    conflicted: false,
    shared: true,
  }));

// 下一份优惠
exports.transformFullCountPromotions = list =>
  list.reduce((result, item) => {
    const { marketRuleDtos, activityDishes } = item;
    const dishes = (activityDishes || []).reduce((total, dish) => (dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish)), []);
    const { productType } = (marketRuleDtos || [])[0] || {};

    const transform = promotion => {
      const benefit = {
        ...promotion,
        benefitKey: promotion.benefitKey || promotion.id,
        benefitId: promotion.id,
        benefitName: promotion.name,
        benefitType: FULL_COUNT_PROMOTIONS,
        canUseDishIds: promotion.activityDishes
          .reduce((total, dish) => (dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish)), [])
          .map(dish => dish.dishId),
        dishKeys: [],
        benefitDishes: [],
        matched: false,
        diff: 0, // 如果不满足条件的差值
        conflicted: false,
        shared: false, // 目前满量（下一份优惠）促销与优惠券一定互斥
      };

      benefit.benefitRuleText = getBenefitTitle(benefit, true);

      return benefit;
    };

    // 如果配置了多个活动商品且活动模式为单商品，拆分为多个活动，每个活动对应一个商品
    if (productType === 1 && dishes.length > 1) {
      result = result.concat(
        dishes.map(dish =>
          transform({
            ...item,
            benefitKey: `${item.id}-${dish.dishId}`, // 根据商品拆分活动，需要一个唯一的key
            activityDishes: [dish],
          }),
        ),
      );
    } else {
      result = result.concat(transform(item));
    }

    return result;
  }, []);

// 是否叠加，算出可以获赠多少份商品
exports.getSuperimpose = function(benefit, dishes) {
  const { stackRule, matched, marketRuleDtos } = benefit;
  let superimpose = 0;
  if (stackRule && matched && marketRuleDtos && marketRuleDtos[0] && marketRuleDtos[0].policySubjectId === 12) {
    const { ruleSubjectId, policyValue1, logicValue } = marketRuleDtos[0];

    // 满量
    if (ruleSubjectId === 11) {
      superimpose = Math.floor(countDishesNumber(dishes) / logicValue) * policyValue1;
    }
    // 满额
    if (ruleSubjectId === 12) {
      superimpose = Math.floor(getDishesBasePrice(dishes) / logicValue) * policyValue1;
    }
  }

  return superimpose;
};

// 获取当前使用的是单商品优惠或者多商品优惠
const getCurrentBenefitType = function(allBenefits) {
  const hasSingle = allBenefits[SINGLE_PROMOTIONS].find(item => item.dishKeys.length > 0);
  const hasMulti = allBenefits[MULTI_PROMOTIONS].find(item => item.dishKeys.length > 0);

  return hasSingle ? SINGLE_PROMOTIONS : hasMulti ? MULTI_PROMOTIONS : '';
};

exports.getCurrentBenefitType = getCurrentBenefitType;

// 海底捞，是否会有单多商品优惠冲突
exports.isBenefitConflict = function(allBenefits, targetType) {
  const mainType = getCurrentBenefitType(allBenefits);

  return mainType
    ? (mainType === SINGLE_PROMOTIONS && targetType === MULTI_PROMOTIONS) || (mainType === MULTI_PROMOTIONS && targetType === SINGLE_PROMOTIONS)
    : false;
};

// 限免优惠是否会有和其他优惠冲突
exports.isLimitFreeConflict = function(allBenefits, currentBenefit = {}, targetType) {
  if (!targetType) return false;
  // const otherBenefit = ''; // 有商品的优惠列表
  // const benefitsList = Object.keys(allBenefits)
  //   .filter(key => key !== LIMIT_PROMOTIONS)
  //   .reduce((list, key) => (allBenefits[key] ? list.concat(allBenefits[key]) : list), [])
  //   .filter(benefit => benefit.dishKeys.length);
  const limitBenefitsList = allBenefits[LIMIT_PROMOTIONS].filter(benefit => benefit.dishKeys.length);
  return limitBenefitsList.length || currentBenefit.benefitType === LIMIT_PROMOTIONS || targetType === LIMIT_PROMOTIONS;
};

/**
 * 将商品划分到优惠中去
 * groups 指定目标分组的名称列表
 * specialKeys 指定要划分的商品范围
 */
const groupDishesToBenefit = function(state, groups, specialKeys) {
  const {
    allBenefits,
    divideDishes,
    customerProps: { isHDL },
  } = state;
  const isInit = !specialKeys;
  let hasMulti = false;
  let hasLimitFree = false;
  let dishPool = isInit ? [...divideDishes] : divideDishes.filter(dish => specialKeys.indexOf(dish.key) > -1);

  groups.forEach(benefitType => {
    if (hasLimitFree && benefitType !== LIMIT_PROMOTIONS) return;
    if (hasMulti && isHDL && benefitType === SINGLE_PROMOTIONS) return;

    allBenefits[benefitType].forEach((benefit, index) => {
      const { canUseDishIds, limitCanUseIds = [], dishKeys } = benefit;
      // let availableDishes = dishPool.filter(dish => canUseDishIds.indexOf(dish.brandDishId) > -1);
      let availableDishes = dishPool.filter(dish => canUseDishIds.indexOf(dish.brandDishId) > -1 || limitCanUseIds.indexOf(dish.key) > -1);
      if (!isInit && dishKeys.length) {
        availableDishes = availableDishes.concat(divideDishes.filter(dish => dishKeys.indexOf(dish.key) > -1));
      }

      const { matched } = isMatchBenefit(benefit, availableDishes);

      // 满足活动条件，将商品划分到活动中
      if (matched) {
        const keys = availableDishes.map(dish => dish.key);
        state = state.setIn(['allBenefits', benefitType, index, 'dishKeys'], keys).setIn(['allBenefits', benefitType, index, 'matched'], matched);
        // 将设置到活动中的商品剔除
        dishPool = dishPool.filter(dish => keys.indexOf(dish.key) === -1);

        if (benefitType === LIMIT_PROMOTIONS) {
          // 限免与其他所有活动互斥
          hasLimitFree = true;
        }

        // 记录是否有多商品活动满足条件，后续海底捞就不再划分商品到单商品活动中
        if (benefitType === MULTI_PROMOTIONS) {
          hasMulti = true;
        }
      } else if (isInit) {
        // 切换tab的时候要重置内容
        state = state.setIn(['allBenefits', benefitType, index, 'dishKeys'], []).setIn(['allBenefits', benefitType, index, 'matched'], false);
      }

      if (isInit) {
        state = state
          .setIn(['allBenefits', benefitType, index, 'benefitDishes'], [])
          .setIn(['allBenefits', benefitType, index, 'conflicted'], false)
          .setIn(['allBenefits', benefitType, index, 'diff'], 0);
      }
    });
  });

  return {
    state,
    dishPool,
  };
};

exports.groupDishesToBenefit = groupDishesToBenefit;

exports.transferBenefitDishes = function(state, benefitType, groups) {
  let keys = [];

  let newState = state.updateIn(['allBenefits', benefitType], list =>
    list.flatMap(item => {
      keys = keys.concat(item.dishKeys);
      return item.merge({
        dishKeys: [],
        conflicted: false,
        matched: false,
        diff: 0,
      });
    }),
  );

  if (keys.length) {
    groups = groups.filter(item => item !== benefitType);
    const { state: updatedState, dishPool } = groupDishesToBenefit(newState, groups, keys);
    newState = updatedState.setIn(['pureDishes'], updatedState.pureDishes.concat(dishPool));
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/helper/order-helper.js